// extracted by mini-css-extract-plugin
export var chevronIcon = "_44-2";
export var teamName = "_44-1";
export var teamSwitcherButton = "_44-0";